<div class="root" [class]="'root--' + type">
    <div class="root__icon"></div>
    <div class="root__text">
        <ng-content></ng-content>
    </div>
</div>
